<template>
  <div class="dialog-wrap">
    <el-dialog
      title="推广文案"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="560px"
    >
      <el-form
        class="form"
        :model="dataForm"
        ref="dataForm"
        label-width="0px"
      >
        <el-form-item>
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="dataForm.promoter_desc"
            :rows="5"
            :limit="9"
          >
          </el-input>

        </el-form-item>
        <el-form-item>
          <el-upload
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="imgVisible">
      <img
        width="100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
  </div>
</template>

<script>
import { marketingChargeEdit } from "@/api/distribution";
import { imgUploadUrl, uploadHeaders } from '@/config/index'
export default {
  components: {

  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content,
      imgVisible: false,
      dialogImageUrl: '',
      fileList: [],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.dataForm = val
      let arr = val.promoter_img_urls ? val.promoter_img_urls.split(',') : []
      this.fileList = arr.map((v) => {
        return {
          url: v
        }
      })
    }
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList
    },
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgVisible = true;
    },
    handleClose() {
      this.dataForm = {}
      this.fileList = []
      this.$emit('close')
    },
    handleSubmit() {
      console.log(this.fileList);
      let arr = this.fileList.map((v) => { return v.url })
      console.log(arr.join(','));
      let query = {
        id: this.dataForm.id,
        promoter_desc: this.dataForm.promoter_desc,
        promoter_img_urls: arr.join(','),
      }
      marketingChargeEdit(query).then(res => {
        this.$message.success(`创建成功`)
        this.$refs['dataForm'].resetFields()
        this.$emit('submit')
        this.handleClose()
      }).catch(error => {
        console.log('error: ', error)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
}
/deep/.el-upload {
  width: 122px;
  height: 122px;
  line-height: 122px;
}
/deep/.el-upload-list__item {
  width: 122px;
  height: 122px;
}
</style>
